// Autogenerated file
export const messageTypesEnum = {
    Mail: "Mail",
    Sms: "Sms",
    Push: "Push",
    WebPush: "WebPush",
    Messenger: "Messenger",
};
export const messageTypes = [
    { label: "Mail", value: "Mail" },
    { label: "Sms", value: "Sms" },
    { label: "Push", value: "Push" },
    { label: "Web Push", value: "WebPush" },
    { label: "Messenger", value: "Messenger" },
];
